<template>
  <div class="benefit-header-block container">
    <h1 class="benefit-header-title">{{ title }}</h1>
    <p class="benefit-header-description">{{ description }}</p>
  </div>
</template>

<script>

import SectionMixin from '@/mixins/sectionMixin'

export default {
    name: 'benefit-header',
    mixins: [SectionMixin],
    components:{
    },
    props: {
      title: String,
      description: String,
    },
}
</script>

<style lang="less" scoped>
  @import "../../../styles/vars.less";

  .benefit-header-block{
    padding: 170px 0 40px;
  }
  .benefit-header-title{
    font-family: @bold;
    font-size: 2.5rem;
    padding-bottom: 23px;
  }
  .benefit-header-description{
    font-family: @medium;
    font-size: 1.125rem;
  }
    @media screen and (max-width: @laptop) {
    .benefit-header-block{
      padding: 140px 60px 40px;
    }
  }
  @media screen and (max-width: 1248px) {
    .benefit-header-block {
        padding: 140px 16px 40px;
    }
}
  @media screen and (max-width: @tablet) {
    .benefit-header-block{
      padding: 120px 16px 40px;
      max-width: 100%;
      margin: 0;
    }
  }

</style>